import ConfigContext from '../contexts/ConfigContext';
import { useContext } from 'react';

export const useConfigContext = () => {
  return useContext(ConfigContext);
};
